import ActivePhoneCallButton from 'components/ActivePhoneCallButton';
import { Session } from 'data/firestore/session/types';
import useSession from 'data/firestore/session/useCollection';
import { query, where } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

const activeStatuses: Session['status'][] = [
    'in-progress',
];

const ActivePhoneCalls = ({ agentId }: { agentId: string }) => {
    const navigate = useNavigate();
    const { data: sessions = [], isLoading } = useSession({
        disabled: !agentId,
        listQueryFn: (ref) => {
            const thirtyMinAgo = Date.now() - 30 * 60 * 1000;
            return query(
                ref,
                where('agentId', '==', agentId),
                where('status', 'in', activeStatuses),
                where('createdAt', '>=', new Date(thirtyMinAgo)),
            );
        },
        track: [agentId],
    });

    const activeCalls = sessions.map((session) => ({
        id: session.id,
        type: session.direction,
        status: session.status,
        startTime: session.createdAt,
        customer: session.customer || {
            phoneNumber: session.direction === 'inbound' ? session.from : session.to,
        },
    }));

    return (
        <ActivePhoneCallButton
            isLoading={isLoading}
            activeCallsCount={sessions.length}
            activeCalls={activeCalls}
            onViewCall={(callId) => navigate(`/${agentId}/voip/history/${callId}`)}
        />
    );
};

export default ActivePhoneCalls;
